export default __webpack_public_path__ + "static/media/macariobuendia.70992c7b.png";